import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import PAGES from "@/seo/pages.json";
import { useLang } from "@/i18n";

// Visible breadcrumb matching the BreadcrumbList JSON-LD emitted at build time
export const Breadcrumb = ({ pageKey }) => {
  const { lang, t } = useLang();
  const page = PAGES[pageKey];
  const parent = page.type === "guide" ? "guides" : page.tool ? "tools" : null;
  const items = [{ to: PAGES.home.paths[lang], label: "PixelEdit Pro" }];
  if (parent) items.push({ to: PAGES[parent].paths[lang], label: t(parent === "guides" ? "footer.guides" : "footer.tools") });
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumb" className="mb-6 flex flex-wrap items-center gap-1 font-mono text-[11px] uppercase tracking-wider text-slate-400">
      {items.map((it) => (
        <span key={it.to} className="flex items-center gap-1">
          <Link to={it.to} className="hover:text-slate-900">{it.label}</Link>
          <ChevronRight className="h-3 w-3" />
        </span>
      ))}
      <span className="text-slate-600" aria-current="page">{page[lang].h1}</span>
    </nav>
  );
};
